import { Programmteilnahme } from '@ps20/bff-models';

export interface PoliceVersand {
  versandArt: PoliceVersandArtEnum;
}

export enum PoliceVersandArtEnum {
  DIGITAL_VOLL_POLICE = 'DIGITAL_VOLL_POLICE',
  DIGITAL_TEIL_POLICE = 'DIGITAL_TEIL_POLICE',
  PAPIER_POLICE = 'PAPIER_POLICE',
}

export function getProgrammteilnahme(policeVersandArt: PoliceVersandArtEnum): Programmteilnahme {
  switch (policeVersandArt) {
    case PoliceVersandArtEnum.DIGITAL_TEIL_POLICE:
      return Programmteilnahme.DIGITALE_TEILPOLICE;
    case PoliceVersandArtEnum.DIGITAL_VOLL_POLICE:
      return Programmteilnahme.DIGITALE_VOLLPOLICE;
    default:
      return Programmteilnahme.PAPIERANTRAG;
  }
}
